module.exports = __webpack_public_path__ + "static/media/evento-carioca-anime-cartaz-divulgacao.9074059b.jpg";